import { findProjects } from "@/declare/api/project/project";
import { findProjectGroups } from "@/declare/api/project/project-group";
import { EventHandlerBase, Pointer, Primitive, PythaEventDataChange, RenderItemType } from "pytha2";
import { GeoIntersection, GeometryBase, Line, Point } from "tnbase";
import { AxisNetPrimitive } from "../primitive/AxisNetPrimitive";

/**
 * 打散并重绘轴网(暂时废除)
 */
export class EventHandlerRedrawAxisNet extends EventHandlerBase {


    /**
     * 处理器默认运行入口
     * @param data 
     * @returns 
     */
    run(data = {}) {
        // params
        const params = this.node.graph.cache.inputObject['PARAMS'];
        const axisNetPrimitives: Primitive[] = params?.axisNetPrimitives || [];

        const pris = [];
        axisNetPrimitives?.forEach(item => {
            // 轴线 节点 单独，其他的放一起
            let axisLineList: Primitive[] = [];
            let gridPointList: Point[] = [];
            let anotherList: Primitive[] = [];

            Object.keys(item?.children)?.forEach(key => {
                let entity = item?.children[key];
                if (!!entity) {
                    if (entity.type === 'AxisLine') {
                        axisLineList.push(entity);
                        item.children[key] = null;
                        delete item.children[key];
                    } else if (entity.type === 'Point') {
                        gridPointList.push(entity.getP());
                        anotherList.push(entity);
                    } else {
                        anotherList.push(entity);
                    }
                }
            })
            const segments = this.processLines(axisLineList, gridPointList);
            segments?.forEach(s => {
                let als = new AxisNetPrimitive("AxisLineSegment");
                als.axisNetUuid = item.uuid;
                this.addPrimitive(als, [s], 0xE54242);
            })

            // anotherList?.forEach(item => {
            //     item.temporary = false;
            //     this.getPythaStorage().primitiveStore.primitiveDict[item.uuid] = item;
            //     item.needRedraw = true;
            // })
            pris.push(item);
        })

        pris?.forEach(item => {
            item.lock = true;
            item.temporary = false;
            this.getPythaStorage().primitiveStore.primitiveDict[item.uuid] = item;
            item.needRedraw = true;
        })

        return true;
    }


    getT(line: Line, point: Point) {
        const lineLength = line.start.distanceTo(line.end);
        const startToPoint = line.start.distanceTo(point);
        const endToPoint = line.end.distanceTo(point);

        // 判断点是否在线段上：如果点到起点和终点的距离之和等于线段的总长度，说明点在该线段上
        if (Math.abs((startToPoint + endToPoint) - lineLength) > 1e-6) {
            return null;
        }

        // 计算 t 值
        return startToPoint / lineLength;  // 返回 t 值，范围 [0, 1]
    }

    // 根据 t 值切割线段
    splitAtT(line: Line, t: number): Line {
        const x = line.start.x + (line.end.x - line.start.x) * t;
        const y = line.start.y + (line.end.y - line.start.y) * t;
        const point = new Point(x, y);
        return new Line(line.start, point);  // 返回起点到 t 点的子线段
    }

    // 处理轴线和网格点并切割线段
    processLines(axisLineList: Primitive[], gridPointList: Point[]): Line[] {
        let resultSegments: Line[] = [];

        for (let axisLinePrimitive of axisLineList) {
            let axisLine: Line = (axisLinePrimitive.geos[0] as Line).clone();
            axisLine.transformMatrix.premultiply(axisLinePrimitive.worldModelMatrix);
            let currentStart = axisLine.start;

            // 1. 计算所有点的 t 值
            let tValues = gridPointList?.map(point => {
                const t = this.getT(axisLine, point);  // 计算每个点的 t 值
                return { point, t };  // 返回点和对应的 t 值
            }).filter(item => !!item.t && item.t >= 0 && item.t <= 1); // 过滤无效的点

            // 2. 按照 t 值升序排序
            tValues?.sort((a, b) => a.t - b.t);

            // 3. 对每个点切割线段
            tValues?.forEach(item => {
                const segment = new Line(currentStart, item.point);
                resultSegments.push(segment); // 添加新的子线段
                currentStart = item.point;  // 更新起点为当前点
            });

            // 4. 添加最后的线段（从最后一个点到线段的终点）
            if (!currentStart.equals(axisLine.end)) {
                resultSegments.push(new Line(currentStart, axisLine.end));
            }
        }

        return resultSegments; // 返回所有切割后的线段
    }


    /**
     * 添加一个图元
     * @param primitive 
     * @param geos  
     */
    addPrimitive(primitive: Primitive, geos: GeometryBase[], color: number) {
        const storage = this.getPythaStorage();
        primitive.geos.push(...geos);
        let keys = Object.keys(primitive.renderItemDict);
        if (keys.length > 0) {
            let renderItem = primitive.renderItemDict[keys[0]];
            renderItem.geoElements = [];
            // renderItem.mat.color.set(0xE54242);
            // renderItem.mat.color.set(color);
            geos.forEach(geo => {
                let geoElementsLength = renderItem.geoElements.length;
                geo.getGeoElementsIdxList().forEach(idx => {
                    renderItem.geoElements.push(idx + geoElementsLength);
                })
            });
            renderItem.renderType = RenderItemType.LINE;
        }
        primitive.lock = true;
        primitive.temporary = false;
        storage.primitiveStore.primitiveDict[primitive.uuid] = primitive;
        primitive.needRedraw = true;
    }
}